const getDefaults = () => {
	return {
		background: {
			groups: '/images/background1.jpg'
		}
	};
};

export default getDefaults;
